import * as React from 'react'
import { authService, homeService } from '../../../../../services'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { SignInForm } from '../components/SignInForm'
import { toast } from 'react-toastify'

type SignInProps = {
  isShow: boolean
}
type SignInState = {
  data: ILoginInfo,
  isLoading: boolean,
  error?: IError,
  isShow: boolean
}

export class SignIn extends React.Component<SignInProps, SignInState> {
  constructor(props: SignInProps) {
    super(props)
    this.state = {
      data: {
        username: '',
        password: '',
        rememberMe: false
      },
      isLoading: false,
      error: undefined,
      isShow: false
    }
    this.toggle = this.toggle.bind(this)
  }

  componentWillReceiveProps(nextProps: SignInProps) {
    this.setState({
      isShow: nextProps.isShow
    })
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = event.target
    const { data } = this.state

    if (name !== 'rememberMe') {
      data[name] = value
    } else {
      data[name] = checked
    }
    this.setState({ data })
  }

  onSignInSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    // handle Builtin authentication
    this.setState({ isLoading: true })
    authService.builtinSignin(this.state.data)
      .then(() => homeService.getAppState()
        .catch(error => toast.error(error.message)))
      .then(() => this.setState({ isLoading: false, isShow: false }))
      .catch(error => this.setState({ isLoading: false, error }))

  }

  toggle() {
    this.setState({
      isShow: !this.state.isShow
    })
  }

  render() {
    const { data, isLoading, error, isShow } = this.state

    return (
      <Modal isOpen={isShow} toggle={this.toggle}>
        <ModalHeader>Sign In</ModalHeader>
        <ModalBody>
          <SignInForm
            data={data}
            isLoading={isLoading}
            error={error}
            onChange={this.onChange}
            onSubmit={this.onSignInSubmit}
          />
        </ModalBody>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Auth/containers/SignIn.tsx